import "../css/main.css";
import "../css/background.css";

import logo from "../images/logo.svg";

import { writeGroupAvatars } from "../components/writeGroupAvatars";
import StdButton from "../components/StdButton";
import useLogin from "./useLogin";
import GenericModal from "../components/GenericModal";

export default function Login({ login }) {
  const {
    avatar,
    setAvatar,
    initWords,
    checkCredentials,
    writeLangButtons,
    inputGroup,
    open,
    closeMsg,
    msgType,
  } = useLogin({ login });

  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="hero">
        <section>
          <div className="air air1"></div>
          <div className="air air2"></div>
          <div className="air air3"></div>
          <div className="air air4"></div>
        </section>
      </div>

      <div className="loginBackground">
        <p style={{ textAlign: "center" }}>
          <img src={logo} alt={"logo"} style={{ width: 200, margin: 20 }} />
        </p>

        {writeGroupAvatars(avatar, setAvatar)}
        <div
          className="centerBox"
          style={{ flexDirection: "row", margin: 10, marginBottom: 30, gap: 5 }}
        >
          {writeLangButtons()}
        </div>
        <div
          className="centerBox"
          style={{
            flexDirection: "row",
            height: 110,
            margin: 10,
          }}
        >
          {/* <div
            style={{
              position: "relative",
              width: 110,
              alignItems: "center",
            }}
          >
            {mainPicture()}
            <div
              style={{
                position: "absolute",
                width: "100%",
                bottom: 0,
                fontSize: 20,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {guser}
            </div>
          </div> */}
          <div
            className="centerBox"
            style={{
              // justifyContent: "end",
              flex: 0.55,
            }}
          >
            {inputGroup()}
          </div>
        </div>

        {/* <div style={{ paddingLeft: 10, paddingBottom: 20 }}>
          <input ref={policy} type="checkbox" /> {initWords.accept}
          <span
            onClick={() => {
              setOpen(true);
            }}
          >
            {initWords.conditionsUse.toLowerCase()}
          </span>
        </div> */}
        <div className="centerBox" style={{ marginTop: 20 }}>
          <StdButton
            label={initWords.initEnter}
            onClick={checkCredentials}
            width={70}
          />
        </div>
      </div>

      <GenericModal open={open} data={msgType[open]} close={closeMsg} />

      {/* <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "auto",
            }}
          >
            <div
              className="mapTitle"
              onClick={() => {
                setOpen(false);
              }}
              style={{
                position: "absolute",
                right: 5,
                top: 5,
                borderRadius: 100,
                height: 40,
                width: 40,
                transition: "left 0.5s, opacity 0.5s",
              }}
            >
              <CancelIcon style={{ color: "red", fontSize: 40 }} />
            </div>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {initWords.conditionsUse}
            </Typography>
            {initWords.conditionsLeyend.map((o, index) => {
              return o === "" ? (
                <div key={index} style={{ height: 20 }}></div>
              ) : (
                <div key={index} dangerouslySetInnerHTML={{ __html: o }}></div>
              );
            })}
          </div>
        </Box>
      </Modal> */}
    </div>
  );
}
